import { Component, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface SaveSearchDialogData {
  name?: string;
  description?: string;
}

@Component({
  selector: "lhpe-save-search-dialog",
  templateUrl: "./save-search-dialog.component.html",
  styleUrls: ["./save-search-dialog.component.scss"],
})
export class SaveSearchDialogComponent {
  nameCtrl = new FormControl("");
  descriptionCtrl = new FormControl("");

  constructor(
    private dialogRef: MatDialogRef<SaveSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SaveSearchDialogData,
  ) {
    this.nameCtrl.setValue(data?.name || "");
    this.descriptionCtrl.setValue(data?.description || "");
  }

  cancel() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({
      name: this.nameCtrl.value || "Untitled Search",
      description: this.descriptionCtrl.value || "",
    });
  }
}


